import {
  FIREBASE_SHARED_RESOURCE_API_KEY,
  FIREBASE_SHARED_RESOURCE_APP_ID,
  FIREBASE_SHARED_RESOURCE_PROJECT_ID,
} from "@polifonia/env";
import { initializeApp } from "firebase/app";
const sharedResourceFirebaseApp = initializeApp(
  {
    apiKey: FIREBASE_SHARED_RESOURCE_API_KEY,
    projectId: FIREBASE_SHARED_RESOURCE_PROJECT_ID,
    appId: FIREBASE_SHARED_RESOURCE_APP_ID,
  },
  "sharedResource",
);

export { sharedResourceFirebaseApp };
